import React, { useState } from 'react';
import { motion } from 'framer-motion';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import MonthSelectorModal from './MonthSelectorModal';

const MONTHS = [
  'Tháng 1',
  'Tháng 2',
  'Tháng 3',
  'Tháng 4',
  'Tháng 5',
  'Tháng 6',
  'Tháng 7',
  'Tháng 8',
  'Tháng 9',
  'Tháng 10',
  'Tháng 11',
  'Tháng 12',
];

interface MonthSelectorProps {
  currentMonth: number;
  handleMonthChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  prevMonth: () => void;
  nextMonth: () => void;
  totalDocs: number;
  handleSortByDate: () => void;
  isDisabled: boolean;
}

const MonthSelector: React.FC<MonthSelectorProps> = ({
  currentMonth,
  handleMonthChange,
  prevMonth,
  nextMonth,
  totalDocs,
  handleSortByDate,
  isDisabled,
}) => {
  const [showMonthModal, setShowMonthModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const openMonthModal = (e: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(e.currentTarget as HTMLElement);
    setShowMonthModal(true);
  };

  const closeMonthModal = () => {
    setAnchorEl(null);
    setShowMonthModal(false);
  };

  const handleSelectMonth = (month: number) => {
    const event = {
      target: { value: month.toString() },
    } as unknown as React.ChangeEvent<HTMLSelectElement>;
    handleMonthChange(event);
  };
  return (
    <motion.div
      className="mb-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.1 }}
    >
      {/* Month Selector */}
      <div className="flex items-center gap-3">
        <motion.button
          onClick={prevMonth}
          disabled={isDisabled}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="p-2 bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 rounded-lg transition-colors disabled:opacity-50"
        >
          <KeyboardArrowLeftIcon fontSize="small" />
        </motion.button>
        
        <motion.button
          ref={(el) => {
            if (el && !anchorEl) setAnchorEl(el);
          }}
          onClick={openMonthModal}
          disabled={isDisabled}
          data-filter-button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="px-4 py-2 bg-[#017e6e] text-white rounded-lg font-medium transition-colors disabled:opacity-50 min-w-[140px] text-sm"
        >
          {MONTHS[currentMonth - 1]}
        </motion.button>

        <motion.button
          onClick={nextMonth}
          disabled={isDisabled}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="p-2 bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 rounded-lg transition-colors disabled:opacity-50"
        >
          <KeyboardArrowRightIcon fontSize="small" />
        </motion.button>
      </div>

      {/* Info and Sort */}
      <div className="flex items-center gap-3">
        <span className="text-sm text-gray-600 dark:text-gray-400">
          Tìm thấy <strong>{totalDocs}</strong> khóa học
        </span>
        <motion.button
          onClick={handleSortByDate}
          disabled={isDisabled}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="px-4 py-2 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-200 rounded-lg text-sm font-medium transition-colors disabled:opacity-50"
        >
          Sắp xếp theo ngày
        </motion.button>
      </div>

      {/* Month Selector Modal */}
      <MonthSelectorModal
        isOpen={showMonthModal}
        closeModal={closeMonthModal}
        currentMonth={currentMonth}
        handleMonthChange={handleSelectMonth}
        anchorEl={anchorEl}
      />
    </motion.div>
  );
};

export default MonthSelector;
